import type { TFonts } from '@lib/utils/fonts'

// Object.freeze allows this to act like an enum while being a complex object
export const Fonts: TFonts = Object.freeze({
  // @TODO: Switch out all otf files for woff2 files when available
  'Super Sans': {
    400: {
      normal: {
        woff2: 'SuperSans-Regular.woff2',
      },
      // Italic example
      // italic: {
      //   otf: 'SuperSans-RegularItalic.otf',
      // },
    },
    500: {
      normal: {
        woff2: 'SuperSans-Medium.woff2',
      },
    },
  },
  'Super Sans Mono': {
    400: {
      normal: {
        woff2: 'SuperSans-Regular.woff2',
      },
    },
  },
  'Super Serif': {
    400: {
      normal: {
        woff2: 'SuperSerif-Regular.woff2',
      },
      italic: {
        woff2: 'SuperSerif-RegularItalic.woff2',
      },
    },
    580: {
      normal: {
        woff2: 'SuperSerif-SemiBold.woff2',
      },
    },
  },
})
